import { green } from "@material-ui/core/colors";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import React, { useEffect } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

const CookieToolbar = () => {
  const sendDataToGTM = useGTMDispatch();
  const consent = getCookieConsentValue();

  const handleAcceptCookies = () => {
    sendDataToGTM({
      event: "consent",
      consent_type: "update",
      functional_storage: "granted",
      security_storage: "granted",
      ad_storage: "granted",
      analytics_storage: "granted",
      personalization_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
    sendDataToGTM({
      event: "consent_update",
      consent_type: "granted",
    });
  };

  const handleDeclineCookies = () => {
    sendDataToGTM({
      event: "consent",
      consent_type: "update",
      functional_storage: "granted",
      security_storage: "granted",
      ad_storage: "denied",
      analytics_storage: "denied",
      personalization_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    sendDataToGTM({
      event: "consent_update",
      consent_type: "denied",
    });
  };

  useEffect(() => {
    if (consent === undefined) {
      sendDataToGTM({
        event: "consent",
        consent_type: "default",
        functional_storage: "granted",
        security_storage: "granted",
        ad_storage: "denied",
        analytics_storage: "denied",
        personalization_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        wait_for_update: 2000,
      });
    }
    if (consent === "true") {
      sendDataToGTM({
        event: "consent",
        consent_type: "update",
        functional_storage: "granted",
        security_storage: "granted",
        ad_storage: "granted",
        analytics_storage: "granted",
        personalization_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
    if (consent === "false") {
      sendDataToGTM({
        event: "consent",
        consent_type: "update",
        functional_storage: "granted",
        security_storage: "granted",
        ad_storage: "denied",
        analytics_storage: "denied",
        personalization_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    }
  }, [consent]);

  return (
    <CookieConsent
      enableDeclineButton
      location="bottom"
      buttonText="Rozumím"
      buttonStyle={{ background: green[500] }}
      declineButtonText={"Odmítnout"}
      declineButtonStyle={{ background: "transparent" }}
      onAccept={handleAcceptCookies}
      onDecline={handleDeclineCookies}
    >
      Tyto webové stránky používají soubory cookies k zajištění funkčnosti webu
      a s Vaším souhlasem i mj. k personalizaci obsahu. Kliknutím na tlačítko
      „Rozumím“ souhlasíte s využívaním cookies a předáním údajů o chování na
      webu pro zobrazení cílené reklamy na sociálních sítích a reklamních sítích
      na dalších webech.
    </CookieConsent>
  );
};

export default CookieToolbar;
